__webpack_require__.p = "/assets/turbo/8d504b76/baurde/_next/";